import {useSelector} from "react-redux";

export function useVideoRoomEventFor(videoRoom, takeFrom, overrideEvent) {
  const events = useSelector(state => state.events)
  let targetEventId = null

  if (takeFrom) {
    switch (takeFrom) {
      case 'event':
        targetEventId = videoRoom.event_id
        break
      case 'active_event':
        targetEventId = videoRoom.active_event_id
        break
      default:
        targetEventId = takeFrom
    }
  }

  // bugfix: in der db war null als string drinnen, daher die abfrage
  if (!targetEventId || targetEventId == "null") {
    if(overrideEvent) {
      targetEventId = overrideEvent.id
    } else {
      targetEventId = videoRoom.active_event_id
    }
  }

  console.debug({targetEventId})

  return events.find(event => event.id === targetEventId)
}